import { differenceInCalendarDays, parseISO } from 'date-fns'

/* Mirror of `getDaysPastDeadline`: whole calendar days left, ignoring the time of day:
   deadline 2025-10-10, today 2025-10-09 => 1
   deadline 2025-10-10, today 2025-10-10 => 0 (last day)
   deadline 2025-10-10, today 2025-10-11 => -1 */
export const getDaysUntilDeadline = (reportDeadline: string): number =>
  differenceInCalendarDays(parseISO(reportDeadline), new Date())
